<template>
    <a
        :href="item.uri"
        class="AlgoliaSearchHit"
    >
        <BaseImage
            :placeholder="`/dist/images/search_fallback_copy.jpg`"
            :srcset="srcset"
            :ratio="1.4"
        >
            <div class="product-location-tag" v-if="location">
                <BaseTag :title="location" style="margin-bottom: 0;" />
            </div>
            <div class="product-deal-tag" v-if="deal">
                <BaseTag classes="BaseTag--squared" :title="'DEAL'" style="margin-bottom: 0;" />
            </div>
        </BaseImage>
        <div>
            <div class="mobile-product-location-tag" v-if="location">
                <BaseTag :title="location" style="margin-bottom: 0;" />
            </div>
            <div class="mobile-product-location-tag" v-if="deal">
                <BaseTag classes="BaseTag--squared" :title="'DEAL'" style="margin-bottom: 0;" />
            </div>
            <BaseHeading
                :heading="item.title"
                tag="h6"
                class="noline"
            />
            <BaseText
                v-if="summary"
                :text="truncatedSummary"
            />
            <ul
                v-if="categories"
            >
                <li
                    v-for="(cat, index) in categories"
                    :key="index"
                    class="mr-small inline"
                >
                    <BaseTag
                        :title="cat|label"
                    />
                </li>
            </ul>
        </div>
    </a>
</template>
<script>
import { truncate } from 'lodash';
import moment from 'moment';

export default {
    name: 'AlgoliaSearchHit',
    filters: {
        label: function (value) {
            return value.split(' > ')[1]
        },
    },
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    computed: {
        srcset() {
            let srcset

            if (this.item.image) {
                if (this.item.image.length > 1) {
                    srcset = `${this.item.image[0]}, ${this.item.image[1]}`
                } else {
                    srcset = this.item.image[0]
                }
            }

            return this.item.image ? srcset : null
        },
        summary() {
            return this.item.summary || this.item.productDescription || this.item.productCustomDescription || null
        },
        categories() {
            return this.item.subcategories || null
        },
        deal() {
            return this.item.deal &&
                this.item.deals && 
                this.item.deals.find((deal) => {
                    const start = moment(deal.start, "DD/MM/YYYY");
                    const end = moment(deal.end, "DD/MM/YYYY");
                    const now = moment();
                    return start.isBefore(now) && now.isBefore(end);
                });
        },
        truncatedSummary() {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = this.item.productCustomDescription || this.item.productDescription || this.item.summary;

            const truncated = truncate(tempDiv.innerText, {
                length: 155,
                separator: /,? +/,
                omission: '...'
            });

            return `<p>${truncated}</p>`;
        },
        location() {
            if(this.item.productLocations && this.item.productLocations.length > 0) {
                return this.item.productLocations[0].city;
            } else {
                return;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .AlgoliaSearchHit {
        display: block;
        margin-bottom: getSpacing(medium);

        @include media-query(smart) {
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid $border-color;
            padding: getSpacing(base) 0;
            margin-bottom: 0;
        }

        @include media-query(desk) {
            margin-bottom: getSpacing(large);
        }

        > div {
             @include media-query(smart) {
                width: calc(75% - 0.75rem);
            }
        }
    }

    .BaseHeading {
        padding-top: 0.5rem;
        margin-top: getSpacing(small);
        margin-bottom: getSpacing(base);

        @include media-query(smart) {
            padding-top: 0;
            margin-top: 0;
            margin-bottom: getSpacing(small);
        }
    }

    .BaseImage {
        @include media-query(smart) {
            width: 25%;
            padding-bottom: 0!important;
            margin-right: getSpacing(small);
            height: 80px;
        }

        @media only screen and (max-width: 420px) {
            height: 50px;
        }
    }

    .BaseText {
        font-size: 0.875rem;
        margin-bottom: getSpacing(medium);

        @include media-query(desk) {
            font-size: 1rem;
        }
        @include media-query(smart) {
            margin-bottom: getSpacing(small);
        }

        ::v-deep p {
            line-height: 1.5;
        }
    }

    ::v-deep h6 {

        @include media-query(palm) {
            font-size: 1.5rem!important;
        }
    }

    .product-location-tag {
        position: absolute; 
        bottom: 1rem; 
        left: 1rem;

        @include media-query(smart) {
            display: none;
        }
    }

    .mobile-product-location-tag, .mobile-product-deal-tag {
        display: none;

        @include media-query(smart) {
            display: inline-block;
            margin-bottom: 8px;
        }
    }

    .product-deal-tag {
        position: absolute; 
        top: 1rem; 
        right: 1rem;

        @include media-query(smart) {
            display: none;
        }
    }
</style>
